export const AGREEMENT_LETTER_TYPE = {
  SEND: "send",
  RECIEVE: "receive",
  SEND_RECEIVE: "send-receive"
};

export const AGREEMENT_TYPE = {
  AGREE: 1,
  REQUEST_CHANGE: 2
};

export const SERVICE_TYPE = {
  SEND_MONEY: "1",
  RECEIVE_MONEY: "2"
};

export const HIGH_RISK_INDUSTRY_VALUE = [
  24, // "Banking"
  25, // "PPOB"
  26, // "Insurance & InsurTech"
  27, // "Payment/Payment Gateway/Remittance"
  28, // "SME Lending"
  29, // "Capital Market"
  30, // "Crypto Exchangers"
  31, // "Koperasi Simpan Pinjam"
  32 // "Koperasi Simpan Pinjam Syariah"
];

export const HIGH_RISK_BUSINESS_FORM = ["pjp", "bmt", "bpr", "bprs", "bank"];
